// extracted by mini-css-extract-plugin
export default {"customRow":"styles_customRow__LQmAl","customHeaderCell":"styles_customHeaderCell__mOdLa"};